import { Wrapper, Header } from "./ReadingStyle"
import ReadingSquares from "./01_squares/ReadingSquares"
import { useSelector } from "react-redux"
import { reading } from "../../i18n/07_reading"

const Reading = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = reading[lang]

  return (
    <Wrapper>
      <Header>
        {t.heading}
      </Header>
      <ReadingSquares />
    </Wrapper>
  )
}

export default Reading